import { createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';

import { RootState } from '@store';
import { ErrorType, ProgrammeReference } from '@types';
import { loadAppData } from '../initialisation';

type StudentProgramme = {
    programmeTypeReference: ProgrammeReference;
    keyStage: number;
};

export interface AppState {
    appError: {
        type: ErrorType;
        error: string | SerializedError;
    } | null;
    studentProgramme: StudentProgramme;
}

export const initialState: AppState = {
    appError: null,
    studentProgramme: {
        // default values
        programmeTypeReference: ProgrammeReference.GCSE,
        keyStage: 1,
    },
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        studentProgrammeSet: (
            state,
            { payload }: PayloadAction<StudentProgramme>,
        ) => {
            state.studentProgramme = payload;
        },
        resetError: (state) => {
            state.appError = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(loadAppData.rejected, (state, { error }) => {
            state.appError = {
                type: ErrorType.LOADING_APP_DATA,
                error,
            };
        });
    },
});

export const { resetError, studentProgrammeSet } = appSlice.actions;

export default appSlice.reducer;

export const appSelector = (state: RootState) => state.app;

export const appErrorSelector = (state: RootState) => state.app.appError;

export const studentProgrammeSelector = (state: RootState) =>
    state.app.studentProgramme;
